import ImageInputContainer from './ImageInputContainer';

export default ImageInputContainer;
